var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 col-sm-6 col-xl-4" }, [
    _c(
      "a",
      {
        staticClass: "one__shop_block d-flex flex-column",
        attrs: { href: _vm.marketLink },
      },
      [
        _c("div", { staticClass: "shop__block_logo" }, [
          _c("img", { attrs: { src: _vm.market.logo, alt: "" } }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop__block_text" }, [
          _vm._v(_vm._s(_vm.shortDescription)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop__block_desc" }, [
          _vm._v(_vm._s(_vm.catchphrase)),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }